import SimpleLine from "../simpleLine";
import NumberText from "../../workspace/text/numberText";
import {COLORS} from "../../../../../../../colorThemes";
import workspace from "../../workspace";
import sqftEventManager from "../../../store/sqftEventManager";
import EventManager from "../../../store/sqftEventManager";
import {DIRECTIONS, getLineDirection, getLineOrientation} from "../../../../../helpers/shapeHelper";
import {isApproximatelyEqual, mmToInches, orientation} from "../../../../../helpers/sqftHelper";
import moveDiagonalLine from "../../../../../lib/moveDiagonalLine";
import sqftConfig from "../../../store/sqftConfig";
import {MEASURE_UNITS} from "../../../../../constants";

class LineImage extends SimpleLine {
  constructor(from, to, parent, lineIndex, settings) {
    super(from, to, parent, settings)

    this.movableImage = parent;
    this.lineIndex = lineIndex;
    const design = {fontColor: COLORS.red, eventsPriority: sqftEventManager.priorities.IMAGE_LINE};
    let xOffset = 0;
    let yOffset = 0;
    switch (lineIndex) {
      case 0:
        xOffset = 0;
        yOffset = 15;
        break;
      case 1:
        xOffset = 0;
        yOffset = -15;
        break;
      case 2:
        xOffset = 0;
        yOffset = 15;
        break;
      case 3:
        xOffset = 0;
        yOffset = 15;
        break;
    }
    // const xOffset = lineIndex === 0 || lineIndex === 2 ? 0 : 15;
    // const yOffset = lineIndex === 0 || lineIndex === 2 ? 15 : 0;

    this.measurementInsideShape = new NumberText(0,
      {xOffset: xOffset, yOffset},
      design,
      workspace,
      this.updatePosInsideShape,
      false
    );
  }

  destroy = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.from.destroy(protect);
      this.lineLengthText.destroy();
      this.measurementInsideShape.destroy();
    }
  };

  deregisterEvents = (protect) => {
    if (!protect) {
      EventManager.removeEvent(this);
      this.isHidden = true;
      this.from.deregisterEvents();
      this.lineLengthText.deregisterEvents();
      this.measurementInsideShape.deregisterEvents();
    }
  };

  reInitEvents = () => {
    if (this.isHidden) {
      this.initEvents();
      this.isHidden = false;

      this.from.reInitEvents();
      this.lineLengthText.reInitEvents();

      if (this.movableImage.shouldRenderMeasurementsInsideTheShape()) {
        const outerShape = this.movableImage.getOuterShape();
        if (outerShape) {
          this.measurementInsideShape.reInitEvents();
        }
      }
    }
  }

  updatePosInsideShape = (val, numberText, prevValue) => {
    let diff = prevValue - val;
    diff = sqftConfig.measureUnit === MEASURE_UNITS.Metric
      ? mmToInches(diff)
      : diff;

    const angleInRadians = this.movableImage.rotatedDegrees * Math.PI / 180; // Предполагая, что rotationAngle - это угол вращения в градусах

    // Calculate the offset taking into account the rotation angle
    const deltaX = diff * Math.cos(angleInRadians);
    const deltaY = diff * Math.sin(angleInRadians);

    const movableImage = this.from.parent;
    const lineIndex = this.lineIndex;
    let posXDiff = 0;
    let posYDiff = 0;
    switch (lineIndex) {
      case 0:
        posXDiff = -deltaY;
        posYDiff = -deltaX;
        break;
      case 1:
        posXDiff = +deltaX;
        posYDiff = +deltaY;
        break;
      case 2:
        posXDiff = +deltaY;
        posYDiff = +deltaX;
        break;
      case 3:
        posXDiff = -deltaX;
        posYDiff = -deltaY;
        break;
    }

    const newPosition = {x: movableImage.pos.x + posXDiff, y: movableImage.pos.y + posYDiff}
    movableImage.setPosition(newPosition);
    movableImage.shapeAbsolute.setAbsolutePos(newPosition);
  };

  /**
   * parent method override
   * @param xDiff
   * @param yDiff
   */
  moveLine = (xDiff, yDiff) => {
    const shape = this.parent;
    const currentSize = this.parent.getSize();
    let newImageWidth = currentSize.width;
    let newImageDepth = currentSize.depth;

    const o = getLineOrientation(this.from, this.to);
    const lineDirection = getLineDirection(this.from, this.to);

    const expandWidth = () => {
      if (lineDirection === DIRECTIONS.WEST) {
        let testNewImageValue = newImageDepth - yDiff;
        if (
          sqftConfig.maxApplianceLineLength > testNewImageValue &&
          sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageDepth = testNewImageValue;
          this.from.y -= yDiff;
          this.to.y -= yDiff;
        }
      } else if (lineDirection === DIRECTIONS.EAST) {
        let testNewImageValue = newImageDepth + yDiff;
        if (
          sqftConfig.maxApplianceLineLength > testNewImageValue &&
          sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageDepth = testNewImageValue;
          this.parent.setPosition({ x: this.parent.pos.x, y: this.parent.pos.y - yDiff });
          this.parent.updateSnappedPos(); // resolve snapping v1
          // move points for the parallel line
          const parallelLine = this.getParallelLine();
          if (parallelLine) {
            parallelLine.from.y += yDiff;
            parallelLine.to.y += yDiff;
          }
        }
      } else if (lineDirection === DIRECTIONS.SOUTH) {
        // For SOUTH in expandWidth, adjust newImageHeight using xDiff
        let testNewImageValue = newImageDepth - xDiff;
        if (
          sqftConfig.maxApplianceLineLength > testNewImageValue &&
          sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageDepth = testNewImageValue;
          // Adjust this line's points by half the xDiff
          this.from.x -= xDiff / 2;
          this.from.y -= xDiff / 2;
          this.to.x -= xDiff / 2;
          this.to.y -= xDiff / 2;
          // Shift parent's position accordingly
          this.parent.setPosition({
            x: this.parent.pos.x - xDiff / 2,
            y: this.parent.pos.y + xDiff / 2,
          });
          this.parent.updateSnappedPos();
          // Update parallel line's points if present
          const parallelLine = this.getParallelLine();
          if (parallelLine) {
            parallelLine.from.x += xDiff / 2;
            parallelLine.from.y -= xDiff / 2;
            parallelLine.to.x += xDiff / 2;
            parallelLine.to.y -= xDiff / 2;
          }
        }
      } else if (lineDirection === DIRECTIONS.NORTH) {
        // For NORTH in expandWidth, adjust newImageHeight using xDiff
        let testNewImageValue = newImageDepth + xDiff;
        if (
          sqftConfig.maxApplianceLineLength > testNewImageValue &&
          sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageDepth = testNewImageValue;
          // Adjust this line's points by half the xDiff
          this.from.x -= xDiff / 2;
          this.from.y += xDiff / 2;
          this.to.x -= xDiff / 2;
          this.to.y += xDiff / 2;
          // Shift parent's position accordingly
          this.parent.setPosition({
            x: this.parent.pos.x - xDiff / 2,
            y: this.parent.pos.y - xDiff / 2,
          });
          this.parent.updateSnappedPos();
          // Update parallel line's points if present
          const parallelLine = this.getParallelLine();
          if (parallelLine) {
            parallelLine.from.x += xDiff / 2;
            parallelLine.from.y += xDiff / 2;
            parallelLine.to.x += xDiff / 2;
            parallelLine.to.y += xDiff / 2;
          }
        }
      }
    };


    const expandHeight = () => {
      if (lineDirection === DIRECTIONS.SOUTH) {
        //set min and max line length
        let testNewImageValue = newImageWidth - xDiff;
        if (sqftConfig.maxApplianceLineLength > testNewImageValue
          && sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageWidth = testNewImageValue;
          this.from.x -= xDiff;
          this.to.x -= xDiff;
        }
      } else if (lineDirection === DIRECTIONS.NORTH) {
        let testNewImageValue = newImageWidth + xDiff;
        if (sqftConfig.maxApplianceLineLength > testNewImageValue
          && sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageWidth = testNewImageValue;
          this.parent.setPosition({x: this.parent.pos.x - xDiff, y: this.parent.pos.y});
          this.parent.updateSnappedPos(); //resolve snapping v1
          //this.parent.resetAbsolutePos();  //resolve snapping v2

          //move points for the parallel line
          const parallelLine = this.getParallelLine();
          parallelLine.from.x += xDiff;
          parallelLine.to.x += xDiff;

          //console.log("newImageWidth", testNewImageValue);
          //console.log("parallelLine.from.y", parallelLine.to.x);
          //console.log("parallelLine.to.y", parallelLine.to.x);
          //console.log("xDiff", xDiff);
        }
      } else if (lineDirection === DIRECTIONS.WEST) {
        // For vertical edge in expandHeight: subtract yDiff from newImageWidth
        let testNewImageValue = newImageWidth - yDiff;
        if (
          sqftConfig.maxApplianceLineLength > testNewImageValue &&
          sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageWidth = testNewImageValue;
          // Adjust this line's points by half the diff (inverse of EAST case)
          this.from.y -= yDiff / 2;
          this.from.x -= yDiff / 2;
          this.to.y -= yDiff / 2;
          this.to.x -= yDiff / 2;
          this.parent.setPosition(
            {x: this.parent.pos.x + yDiff / 2,
            y: this.parent.pos.y - yDiff / 2
          });
          this.parent.updateSnappedPos(); //resolve snapping v1
          // Update parallel line's points if present
          const parallelLine = this.getParallelLine();
          if (parallelLine) {
            parallelLine.from.y += yDiff / 2;
            parallelLine.from.x -= yDiff / 2;
            parallelLine.to.y += yDiff / 2;
            parallelLine.to.x -= yDiff / 2;
          }
        }
      } else if (lineDirection === DIRECTIONS.EAST) {
        let testNewImageValue = newImageWidth + yDiff;
        if (sqftConfig.maxApplianceLineLength > testNewImageValue
          && sqftConfig.minApplianceLineLength < testNewImageValue
        ) {
          newImageWidth = testNewImageValue;
          this.from.y -= yDiff / 2 ;
          this.from.x += yDiff / 2 ;
          this.to.y -= yDiff / 2 ;
          this.to.x += yDiff / 2 ;
          this.parent.setPosition({
            x: this.parent.pos.x - yDiff / 2,
            y: this.parent.pos.y - yDiff / 2
          });
          this.parent.updateSnappedPos(); //resolve snapping v1
          //this.parent.resetAbsolutePos(); //resolve snapping v2

          //move points for the parallel line
          const parallelLine = this.getParallelLine();
          parallelLine.from.y += yDiff / 2 ;
          parallelLine.from.x += yDiff / 2 ;
          parallelLine.to.y += yDiff / 2 ;
          parallelLine.to.x += yDiff / 2 ;
        }
      }
    }

    if (o === orientation.VERTICAL) {
      if (isApproximatelyEqual(shape.rotatedDegrees, 0, 3)
        || isApproximatelyEqual(shape.rotatedDegrees, 180, 3)
      ) {
        expandHeight();
      } else {
        expandWidth();
      }
    } else if (o === orientation.HORIZONTAL) {
      if (isApproximatelyEqual(shape.rotatedDegrees, 0, 3)
        || isApproximatelyEqual(shape.rotatedDegrees, 180, 3)
      ) {
        expandWidth();
      } else {
        expandHeight();
      }
    } else {
      const nextLine = this.parent.getNextLine(this);
      const prevLine = this.parent.getPrevLine(this);
      moveDiagonalLine(this, nextLine, prevLine, this.state.movePointDistance, yDiff, o);
      //newImageWidth += xDiff;
      //newImageHeight += yDiff;
    }

    this.parent.updateLinesLength();
    this.updatePrentSize(newImageWidth, newImageDepth);
  }
  getMaxLength = () => sqftConfig.maxApplianceLineLength * sqftConfig.getMeasureMultiplier()
}

export default LineImage;
